const RESOURCE_NAME = '/maintenance-inspection-forms';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
});